export interface UserInfo {
  id: number;
  username: string;
  email?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  full_name?: string;
}

export interface ResolutionInfo {
  resolved_at: string | null;
  resolved_by: string | UserInfo | null;
  action: 'approved' | 'rejected';
  details?: string;
}

export type RequestType = 'absence' | 'clock_modification';
export type RequestStatus = 'approved' | 'rejected' | 'validated';

export class ProcessedRequest {
  uuid: string;
  request_type: RequestType;
  user_id: number;
  user_info: UserInfo;
  status: RequestStatus;
  resolution_info: ResolutionInfo | null;

  // Para ausencias
  start?: string;
  end?: string;
  reason?: string;
  tipoAusencia?: string;

  // Para modificaciones de horario
  original_timestamp?: string;
  proposed_timestamp?: string;
  clock_type?: string;
  justification?: string;
  approval_date?: string;

  constructor(data: {
    uuid: string;
    request_type: RequestType;
    user_id: number;
    user_info: UserInfo;
    status: RequestStatus;
    resolution_info?: ResolutionInfo | null;
    start?: string;
    end?: string;
    reason?: string;
    tipoAusencia?: string;
    original_timestamp?: string;
    proposed_timestamp?: string;
    clock_type?: string;
    justification?: string;
    approval_date?: string;
  }) {
    this.uuid = data.uuid;
    this.request_type = data.request_type;
    this.user_id = data.user_id;
    this.user_info = data.user_info;
    this.status = data.status;
    this.resolution_info = data.resolution_info || null;
    this.start = data.start;
    this.end = data.end;
    this.reason = data.reason;
    this.tipoAusencia = data.tipoAusencia;
    this.original_timestamp = data.original_timestamp;
    this.proposed_timestamp = data.proposed_timestamp;
    this.clock_type = data.clock_type;
    this.justification = data.justification;
    this.approval_date = data.approval_date;
  }


  getEmployeeDisplayName(): string {
    if (this.user_info.first_name) {
      let fullName = this.user_info.first_name;
      if (this.user_info.last_name) {
        fullName += ' ' + this.user_info.last_name;
      }
      return fullName;
    }
    return this.user_info.username || 'Desconocido';
  }

  
  //Fecha de resoluciónn formatead
  getResolutionDate(): string | null {
    if (this.resolution_info?.resolved_at) {
      return this.resolution_info.resolved_at;
    }
    if (this.approval_date) {
      return this.approval_date;
    }
    return null;
  }

  
  
  // Comprobar si ha sido aprobada o si no
  isApproved(): boolean {
    return this.status === 'approved' || this.status === 'validated';
  }

  
  
  //Check if the request was rejected
  isRejected(): boolean {
    return this.status === 'rejected';
  }

  
  
  //Get the request type label in Spanish
  getRequestTypeLabel(): string {
    if (this.request_type === 'absence') {
      return this.tipoAusencia || 'Ausencia';
    }
    return 'Modificación de fichaje';
  }

  
  //Get the status label in Spanish
   
  getStatusLabel(): string {
    if (this.isApproved()) {
      return 'Aprobado';
    }
    return 'Rechazado';
  }
}
